export const CapaFieldLabels = {
  title: 'Title',
  summary: 'Summary',
  source: 'Source',
  sourceReference: 'Source Reference',
  description: 'Description',
  capaOwner: 'Capa Owner',
  severity: 'Severity',
  probability: 'Probability',
  correctiveActions: 'Corrective Actions',
  investigator: 'Investigator',
  rootCause: 'Root Cause',
  rootCauseRationale: 'Root Cause Rationale',
  preventiveAction: 'Preventive Action',
  trainingNeeded: 'Training Needed',
  verification: 'Verification',
  attachment: 'Attachments',
  assignTask: 'Assign Task',
  taskFiles: 'Document References'
} as const;

export type CapaField = keyof typeof CapaFieldLabels;

export const CapaFields: CapaField[] = Object.keys(
  CapaFieldLabels
) as CapaField[];
